import { getWithRootPathGetter } from '@/api/utils';

const withRoot = getWithRootPathGetter('/opobff/opo-platform');

export const opobffOrganizationApiPaths = {
  organization: withRoot('/organization'),
} as const;

export const getOpobffOrganizationApiUrl = {
  organization: () => opobffOrganizationApiPaths.organization,
};
